import { render, staticRenderFns } from "./TemplateProductPage.vue?vue&type=template&id=5a153e44"
import script from "./TemplateProductPage.vue?vue&type=script&lang=js"
export * from "./TemplateProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports